module.exports = __webpack_public_path__ + "static/img/VN.a01343d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/VN.svg
// module id = UVXj
// module chunks = 66